import React from 'react'

const Loader = ({ value = 0, className = '', ...other }) => {
  const pct = Math.min(100, Math.max(0, Number(value) || 0))
  return (
    <div
      className={`edvi-loader ${className}`.trim()}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      {...other}
    >
      <div className="edvi-loader__bar" style={{ width: `${pct}%` }} />
    </div>
  )
}

export default Loader
